import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'
const LEASE_OPTIONS = `${PRIVATE_ROOT}/lease-options`

export const EXTENSION = `${LEASE_OPTIONS}/extensions`
export const ADD_EXTENSION_REQUEST = `${LEASE_OPTIONS}/add-extension-request`
export const EXTENSION_REQUEST_REJECTED = `${LEASE_OPTIONS}/extension-request-rejected`
export const EXTENSION_REQUEST_OPEN = `${LEASE_OPTIONS}/extension-request-open`
export const EXTENSION_REQUEST_ACCEPTED = `${LEASE_OPTIONS}/extension-request-accepted`
